import React from 'react';

const colors = {
  success: { bg: 'var(--success-bg)', border: 'rgba(52,211,153,0.3)', color: 'var(--success)' },
  error:   { bg: 'var(--danger-bg)',  border: 'rgba(248,113,113,0.3)', color: 'var(--danger)' },
  warning: { bg: 'var(--warning-bg)', border: 'rgba(251,191,36,0.3)',  color: 'var(--warning)' },
};

export default function Toast({ message, type = 'success' }) {
  const c = colors[type] || colors.success;
  return (
    <div className="toast" style={{
      position: 'fixed',
      bottom: 24,
      right: 24,
      background: 'var(--bg-card2)',
      border: `1px solid ${c.border}`,
      borderLeft: `3px solid ${c.color}`,
      borderRadius: 10,
      padding: '10px 18px',
      color: c.color,
      fontFamily: 'DM Sans, sans-serif',
      fontSize: 13,
      fontWeight: 500,
      boxShadow: 'var(--shadow)',
      zIndex: 500,
      maxWidth: 360,
      animation: 'fadeUp 0.2s ease',
    }}>
      <style>{`@keyframes fadeUp { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }`}</style>
      {message}
    </div>
  );
}
